import * as yup from 'yup';
import { EMPTY_ARRAY, Row, Column, RenderConfig, AsyncSelect, SelectInput, BOOLEAN_OPTIONS, SUB_APP_GAME_NAME } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	VERSION_NUMBER: 'versionCode',
	IS_FORCE_UPDATE: 'isForceUpdate',
	SUB_APP_APK_URL_V8: 'apkUrlArmV8',
	SUB_APP_APK_URL_V7: 'apkUrlArmV7',
	GAME_NAME: 'gameName'
};

export const validationSchema = yup.object().shape({
	isForceUpdate: yup.boolean().required('Is Force Update a required field')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.VERSION_NUMBER]: new RenderConfig()
		.setName('versionCode')
		.setLabel('Update to this version number')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: [],
			dependencies: ['gameName']
		}),
	[FORM_FIELD_KEYS.IS_FORCE_UPDATE]: new RenderConfig()
		.setName('isForceUpdate')
		.setLabel('Is Force Update')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			inputType: 'boolean',
			required: true,
			options: BOOLEAN_OPTIONS
		}),
	[FORM_FIELD_KEYS.GAME_NAME]: new RenderConfig()
		.setName('gameName')
		.setLabel('Sub app game name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: SUB_APP_GAME_NAME
		}),
	[FORM_FIELD_KEYS.SUB_APP_APK_URL_V8]: new RenderConfig()
		.setName('apkUrlArmV8')
		.setLabel('Apk url V8')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			isHidden: { create: true, edit: true },
			inputType: 'string',
			required: true
		}),
	[FORM_FIELD_KEYS.SUB_APP_APK_URL_V7]: new RenderConfig()
		.setName('apkUrlArmV7')
		.setLabel('Apk url V7')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			isHidden: { create: true, edit: true },
			inputType: 'string',
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.GAME_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.VERSION_NUMBER)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.IS_FORCE_UPDATE)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.SUB_APP_APK_URL_V7)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.SUB_APP_APK_URL_V8)])])
];

export const getFormDefaults = () => {
	return {};
};
